import type { ListColorFragment } from './ListColorFragment.generated';
import { useListColorFragment } from './ListColorFragment.generated';

export type ListColor = NonNullable<ListColorFragment['color']>;

export const DEFAULT_LIST_COLOR: ListColor = 'gray';

/**
 * Returns the color attribute for a list.
 *
 * @default gray
 */
export const useListColor = (listId: string): ListColor => {
  const { data } = useListColorFragment({
    from: { id: listId },
    optimistic: true,
  });
  return data?.color ?? DEFAULT_LIST_COLOR;
};
